import { lazy, Suspense } from 'react';
import { Route, Navigate } from 'react-router-dom';
import { BASE } from './config';
import { isAuthed } from './api';
import './presupuestos.css';

/* Páginas lazy: jspdf + html2canvas son pesados, así que el módulo de
   presupuestos se sirve en un chunk aparte y no infla el bundle del landing. */
const Home = lazy(() => import('./pages/Home'));
const ProposalView = lazy(() => import('./pages/ProposalView'));
const AdminLogin = lazy(() => import('./pages/AdminLogin'));
const AdminList = lazy(() => import('./pages/AdminList'));
const AdminEdit = lazy(() => import('./pages/AdminEdit'));

function Cargando() {
  return (
    <div className="psp">
      <div className="viewer-loading">
        <div>
          <div className="spinner" />
          Cargando…
        </div>
      </div>
    </div>
  );
}

const conSuspense = (el) => <Suspense fallback={<Cargando />}>{el}</Suspense>;

/* Protege el panel admin: sin contraseña guardada redirige al login. */
function RequireAuth({ children }) {
  return isAuthed() ? children : <Navigate to={`${BASE}/admin/login`} replace />;
}

/**
 * Rutas del módulo de presupuestos. Se montan dentro del <Routes> de la app.
 * El visor público (`p/:token`) y el login NO requieren auth;
 * el listado y el editor van protegidos.
 * El acceso público es por token (UUID impredecible), no por código.
 */
const presupuestosRoutes = (
  <Route path={BASE}>
    <Route index element={conSuspense(<Home />)} />
    <Route path="p/:token" element={conSuspense(<ProposalView />)} />
    <Route path="admin/login" element={conSuspense(<AdminLogin />)} />
    <Route
      path="admin"
      element={<RequireAuth>{conSuspense(<AdminList />)}</RequireAuth>}
    />
    <Route
      path="admin/:codigo"
      element={<RequireAuth>{conSuspense(<AdminEdit />)}</RequireAuth>}
    />
  </Route>
);

export default presupuestosRoutes;
